$_vikon(document).on('click', '.page-with-back-url', () => {
    const backUrl = window.location.pathname + window.location.hash;
    if (window.sessionStorage) {
        sessionStorage.setItem('back_url', backUrl);
    } else if (navigator.cookieEnabled === true) {
        deleteCookie('back_url');
        setCookie('back_url', backUrl, {path: '/'});
    }
});

$_vikon('#vikon-wrapper').on('click', '.close-modal, .return, .button-return-container', () => {
    let backUrl;
    if (window.sessionStorage && sessionStorage.getItem('back_url')) {
        backUrl = sessionStorage.getItem('back_url');
        sessionStorage.removeItem('back_url');
        window.location.replace(backUrl);
    } else if (navigator.cookieEnabled === true && getCookie('back_url')) {
        backUrl = getCookie('back_url');
        deleteCookie('back_url');
        window.location.replace(backUrl);
    } else if (window.history.length > 1) {
        window.history.back();
    } else {
        window.location.replace(window.location.hostname.indexOf('db-nica.ru') !== -1 ? '/sveden/abitur' : '/abitur');
    }
});

// возвращает cookie с именем name, если есть, если нет, то undefined
function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
        `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
    options = options || {};

    let {expires} = options;

    if (typeof expires === 'number' && expires) {
        const d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = `${name}=${value}`;

    for (const propName in options) {
        updatedCookie += `; ${propName}`;
        const propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += `=${propValue}`;
        }
    }

    document.cookie = updatedCookie;
}

function deleteCookie(name) {
    setCookie(name, '', {
        expires: -1,
    });
}
